// src/pages/Blog.js
// HomeIQa Blog listing page
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import articles from '../data/articles';

export default function Blog() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div style={s.page}>
      {/* NAV BAR */}
      <nav style={s.nav}>
        <Link to="/" style={s.logoLink}>
          <span style={s.logo}>HomeIQa</span>
        </Link>
        <div style={s.navLinks}>
          <Link to="/blog" style={s.navLink}>Blog</Link>
          <Link to="/start" style={s.navCta}>Get My Report</Link>
        </div>
      </nav>

      {/* HEADER */}
      <header style={s.header}>
        <h1 style={s.headerTitle}>HomeIQa Insights</h1>
        <p style={s.headerSub}>
          Expert guidance on home valuation, real estate trends, and property investment
        </p>
      </header>

      {/* ARTICLE GRID */}
      <section style={s.grid}>
        {articles.map((article) => (
          <article key={article.slug} style={s.card}>
            {/* Thumbnail placeholder */}
            <div style={s.thumbnail}>
              <span style={s.thumbIcon}>&#9751;</span>
            </div>
            <div style={s.cardBody}>
              <div style={s.meta}>
                <span>{article.date}</span>
                <span style={s.metaDot}>&middot;</span>
                <span>{article.readTime}</span>
              </div>
              <h2 style={s.cardTitle}>
                <Link to={`/blog/${article.slug}`} style={s.cardTitleLink}>
                  {article.title}
                </Link>
              </h2>
              <p style={s.excerpt}>{article.excerpt}</p>
              <Link to={`/blog/${article.slug}`} style={s.readMore}>
                Read More &rarr;
              </Link>
            </div>
          </article>
        ))}
      </section>

    </div>
  );
}

/* ---------- STYLES ---------- */
const s = {
  page: {
    minHeight: '100vh',
    background: '#FAF7F2',
    fontFamily: "'Inter', 'DM Sans', sans-serif",
    color: '#1a1a2e',
  },

  /* Nav */
  nav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: 1100,
    margin: '0 auto',
    padding: '18px 24px',
  },
  logoLink: {
    textDecoration: 'none',
  },
  logo: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 22,
    fontWeight: 700,
    color: '#5B1A2A',
  },
  navLinks: {
    display: 'flex',
    alignItems: 'center',
    gap: 20,
  },
  navLink: {
    fontSize: 14,
    color: '#5B1A2A',
    textDecoration: 'none',
    fontWeight: 500,
  },
  navCta: {
    fontSize: 13,
    fontWeight: 600,
    color: '#fff',
    background: '#D4A017',
    padding: '8px 18px',
    borderRadius: 6,
    textDecoration: 'none',
  },

  /* Header */
  header: {
    textAlign: 'center',
    padding: '48px 24px 32px',
    maxWidth: 700,
    margin: '0 auto',
  },
  headerTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 40,
    fontWeight: 700,
    color: '#5B1A2A',
    margin: '0 0 12px',
    lineHeight: 1.2,
  },
  headerSub: {
    fontSize: 17,
    color: '#555',
    lineHeight: 1.5,
    margin: 0,
  },

  /* Grid */
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 480px), 1fr))',
    gap: 28,
    maxWidth: 1100,
    margin: '0 auto',
    padding: '16px 24px 64px',
  },

  /* Card */
  card: {
    background: '#fff',
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 2px 12px rgba(91,26,42,0.06)',
    transition: 'box-shadow 0.2s',
    display: 'flex',
    flexDirection: 'column',
  },
  thumbnail: {
    height: 160,
    background: 'linear-gradient(135deg, #5B1A2A 0%, #8B3A4A 40%, #D4A017 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  thumbIcon: {
    fontSize: 40,
    color: 'rgba(255,255,255,0.3)',
  },
  cardBody: {
    padding: '20px 24px 24px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  meta: {
    fontSize: 12,
    color: '#888',
    marginBottom: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  metaDot: {
    color: '#ccc',
  },
  cardTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 20,
    fontWeight: 700,
    color: '#5B1A2A',
    margin: '0 0 10px',
    lineHeight: 1.3,
  },
  cardTitleLink: {
    color: 'inherit',
    textDecoration: 'none',
  },
  excerpt: {
    fontSize: 14,
    color: '#555',
    lineHeight: 1.6,
    margin: '0 0 16px',
    flex: 1,
  },
  readMore: {
    fontSize: 14,
    fontWeight: 600,
    color: '#D4A017',
    textDecoration: 'none',
  },
};
